import gql from 'graphql-tag';

const GET_REMOTE_STORE = gql`
    query getRemoteStore ($latitude: String, $longitude: String) {
        getRemoteStore(latitude: $latitude, longitude: $longitude) {
            local_id,
            local_name,
            local_code,
            sales_channel
        }
    }
`;

export default GET_REMOTE_STORE;
